import React from 'react';

import { Link } from '@raystack/apsara';

import { CustomCodeBlock } from '@src/components/CoPilot/CodeBlock';

// Import your styles
import styles from './CustomRenderMd.module.css';

export const CustomMarkdownRenderers = {
  h1: ({ children }: { children: React.ReactNode }) => (
    <h1 className={styles.customHeading}>{children}</h1>
  ),
  h2: ({ children }: { children: React.ReactNode }) => (
    <h2 className={styles.customHeading}>{children}</h2>
  ),
  h3: ({ children }: { children: React.ReactNode }) => (
    <h3 className={styles.customHeading}>{children}</h3>
  ),
  p: ({ children }: { children: React.ReactNode }) => (
    <p className={styles.customParagraph}>{children}</p>
  ),
  ul: ({ children }: { children: React.ReactNode }) => (
    <ul className={styles.customList}>{children}</ul>
  ),
  ol: ({ children }: { children: React.ReactNode }) => (
    <ol className={styles.customList}>{children}</ol>
  ),
  li: ({ children }: { children: React.ReactNode }) => (
    <li className={styles.customListItem}>{children}</li>
  ),
  strong: ({ children }: { children: React.ReactNode }) => (
    <strong className={styles.customStrong}>{children}</strong>
  ),
  // Modify the 'a' tag renderer to match the expected type
  a: ({ children, href }: { children: React.ReactNode; href?: string }) => {
    const url = href ?? '#'; // Provide a fallback if href is undefined
    return (
      <Link href={url} variant='accent' external data-test-id='linkstyle'>
        {children}
      </Link>
    );
  },

  // Use CodeBlock component for code blocks
  code({
    inline,
    className,
    children,
    ...props
  }: {
    inline?: boolean;
    className?: string;
    children: React.ReactNode;
  } & React.ComponentPropsWithRef<'code'>) {
    const language = className
      ? className.replace('language-', '')
      : 'plaintext';

    return inline ? (
      <code className={styles.inlineCode} {...props}>
        {children}
      </code>
    ) : (
      <CustomCodeBlock language={language} value={children as string} />
    );
  }
};
